import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addSalaryStructureAssignment = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Salary Structure Assignment',
    body
  );
  return data;
});
export const updateSalaryStructureAssignment = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Salary Structure Assignment/${id}`,
    body
  );
  return data;
});

export const getSalaryStructureAssignment = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Salary Structure Assignment?fields=["name","docstatus","employee_name","from_date","payroll_payable_account"]'
  );
  return data;
});
export const deleteSalaryStructureAssignment = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Salary Structure Assignment/${record}`
  );
  return data;
});
export const getSalaryStructureAssignmentDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Salary Structure Assignment/${id}`
  );
  return data;
});
